import { useEffect, useState } from "react";
import { useDebounce } from "use-debounce";
import { Route, Routes, useLocation } from "react-router-dom";
import PropertyTopHeader from "../../newComponents/listings/top-listing-headers/property-listing-top-header";
import PropertyCard from "../../newComponents/listings/listing-cards/property";
import { infiniteScrollHook } from "../../hooks/infiniteScrollHook";
import { PropertyService, AccessLevelEnum } from "@propertelligent/client-api";
import AddProperty from "../../newComponents/property/AddProperty";
import EditProperty from "../../newComponents/property/EditProperty";
import PropertyDetails2 from "../../newComponents/property/PropertyDetails";
import { usePermissions } from "../../hooks/usePermissions";
import NoAccess from "../NoAccess";
import { PermissionGuard } from "../../newComponents/PermissionGuard";

const Properties = () => {
  const { hasAccess, canWrite } = usePermissions();
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState("");
  const [fullyQualifiedFilter, setFullyQualifiedFilter] = useState<string | null>(null);
  const [debouncedSearchTerm] = useDebounce(searchTerm, 500);
  const [ptyTypeId, setPtyTypeId] = useState();

  if (!hasAccess("Property", 1)) {
    return <NoAccess />;
  }

  // For Empty State
  const [hasAnyProperties, setHasAnyProperties] = useState<boolean>(false);

  const {
    rows,
    loading,
    hasMore,
    rowCount,
    fetchData,
    replaceRow,
    currentPage,
  } = infiniteScrollHook({
    httpFetchDataFn: PropertyService.getApiPropertyOrganizationlist,
    FullyQualifiedFilters: fullyQualifiedFilter,
    pageSize: 10,
  });

  useEffect(() => {
    if (debouncedSearchTerm !== "") {
      setFullyQualifiedFilter(
        `Address.StreetAddress.ToLower().Contains("${debouncedSearchTerm.toLowerCase()}")`
      );
    } else {
      setFullyQualifiedFilter(null);
    }
  }, [debouncedSearchTerm]);

  useEffect(() => {
    fetchData(1);
  }, [location]);

  useEffect(() => {
  if (rowCount > 0) {
    setHasAnyProperties(true);
  }
  }, [rowCount]);

  return (
    <>
      <Routes>
        <Route
          index
          element={
            <PermissionGuard permission="Property" level={AccessLevelEnum.ReadOnly} fallback={<NoAccess />}>
              <div className="content-wrapper container-fluid">
                {hasAnyProperties && (
                  <PropertyTopHeader
                    PageHeading="Properties"
                    Count={rowCount}
                    ButtonName="Add Property"
                    MobileButtonName="Add"
                    setSearchTerm={setSearchTerm}
                    searchTerm={searchTerm}
                    showAddButton={canWrite("Property")}
                  />
                )}
                <PropertyCard
                  Id="property"
                  IsFooter={true}
                  hasAnyProperties={hasAnyProperties}
                  dataHookState={{
                    rows,
                    loading,
                    hasMore,
                    fetchData,
                    replaceRow,
                    currentPage,
                  }}
                />
              </div>
            </PermissionGuard>
          }
        />
        <Route path="/create" element={
            <PermissionGuard permission="Property" level={AccessLevelEnum.All} fallback={<NoAccess />}>
              <AddProperty
                ptyTypeId={ptyTypeId}
                setPtyTypeId={setPtyTypeId}
                navigateto={"/properties/addunittanent"}
                fetchData={fetchData}
              />
            </PermissionGuard>
          }
        />
        <Route path="/edit/:propertyId" element={
          <PermissionGuard permission="Property" level={AccessLevelEnum.All} fallback={<NoAccess />}>
            <EditProperty propertyId={ptyTypeId} />
          </PermissionGuard>
        }/>
        <Route path="/propertydetails/:id" element={
          <PermissionGuard permission="Property" level={AccessLevelEnum.ReadOnly} fallback={<NoAccess />}>
            <PropertyDetails2/>
          </PermissionGuard>
        } />
      </Routes>
    </>
  );
};

export default Properties;
